/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_Effort_Hard_TimeInputs */

const en_us2_workout_quick_effort_hard_time = /** @type {(inputs: Workout_Quick_Effort_Hard_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a little left`)
};

const pt_br2_workout_quick_effort_hard_time = /** @type {(inputs: Workout_Quick_Effort_Hard_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dava um pouco`)
};

const es_419_workout_quick_effort_hard_time = /** @type {(inputs: Workout_Quick_Effort_Hard_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`quedaba poco`)
};

const pt_pt2_workout_quick_effort_hard_time = /** @type {(inputs: Workout_Quick_Effort_Hard_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dava um pouco`)
};

const fr_fr2_workout_quick_effort_hard_time = /** @type {(inputs: Workout_Quick_Effort_Hard_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`un peu de marge`)
};

const de_de2_workout_quick_effort_hard_time = /** @type {(inputs: Workout_Quick_Effort_Hard_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`etwas übrig`)
};

const it_it2_workout_quick_effort_hard_time = /** @type {(inputs: Workout_Quick_Effort_Hard_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ne avevo ancora un po'`)
};

/**
* | output |
* | --- |
* | "a little left" |
*
* @param {Workout_Quick_Effort_Hard_TimeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_effort_hard_time = /** @type {((inputs?: Workout_Quick_Effort_Hard_TimeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Effort_Hard_TimeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_effort_hard_time(inputs)
	if (locale === "es-419") return es_419_workout_quick_effort_hard_time(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_effort_hard_time(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_effort_hard_time(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_effort_hard_time(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_effort_hard_time(inputs)
	return en_us2_workout_quick_effort_hard_time(inputs)
});
export { workout_quick_effort_hard_time as "workout-quick.effort_hard_time" }